import { Navigate, Outlet } from "react-router-dom";
import React from "react";
import paths from "paths";
import { useStateContext } from "state";

const AdminRouteWidget: React.FC = () => {
    const state = useStateContext();

    return state.user?.isAdmin ? <Outlet /> : <Navigate to={paths.open.LOGIN} />
};
export default AdminRouteWidget;
